"use client";
import { Button } from "components/ui/button";
import { Sheet, SheetContent } from "components/ui/sheet";
import { Menu } from "lucide-react";
import { useState } from "react";
import Link from "next/link";

const MenuSheet = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="lg:hidden">
      <div className="flex justify-between py-2">
        <Button
          variant="ghost"
          onClick={() => {
            setIsMobileMenuOpen(true);
          }}
        >
          <Menu />
        </Button>
      </div>
      <Sheet
        open={isMobileMenuOpen}
        onOpenChange={(isOpen) => setIsMobileMenuOpen(isOpen)}
      >
        <SheetContent className="overflow-y-auto">
          <div className="flex flex-col items-center gap-4">
            <Link href="/login">{"Se connecter"}</Link>

            <Link
              href="/sign-up"
              className="relative inline-flex items-center justify-center px-3 h-[34px] overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out rounded shadow-xl group hover:ring-1 hover:ring-purple-500"
            >
              <span className="absolute inset-0 w-full h-full bg-gradient-to-br from-blue-600 via-purple-600 to-pink-700"></span>
              <span className="absolute bottom-0 right-0 block w-64 h-64 mb-32 mr-4 transition duration-500 origin-bottom-left transform rotate-45 translate-x-24 bg-pink-500 rounded opacity-30 group-hover:rotate-90 ease"></span>
              <span className="relative text-white">{"Créer un compte"}</span>
            </Link>

            <Link href="/help" legacyBehavior passHref>
              {"Documentation"}
            </Link>

            <Link href="/blog" legacyBehavior passHref>
              {"Blog"}
            </Link>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MenuSheet;
